<!-- spinner -->
@if(loading) {
  <div class="spinner-container">
    <ngb-spinner></ngb-spinner>
  </div> 
}

<!-- navbar -->
@if(!isLogin && !isErrorPage && !isRegistration && isAuthenticated) {
    <mat-toolbar>
      <div class="image-container">
          <img src="https://placehold.co/35x35" alt="logo">
      </div>
      <div class="iconColor">
        <mat-icon icon [matBadge]="badgeNumber()" matTooltip="Prenotazioni in attesa" aria-hidden="false">notifications</mat-icon>
        <mat-icon  (click)="onLogout()">exit_to_app</mat-icon>
        <mat-menu #profileMenu="matMenu" class="custom-menu">
        <div class="profile">
        <h3>{{ profile().name }} {{ profile().surname }}</h3>
            <p>Email: {{ profile().email }}</p>
            <p>Ruolo: {{ profile().permissions[0] }}</p>
            <p>Permessi: {{ profile().permissions.join(', ') }}</p>
            <p>Status: {{ profile().status }}</p>
        </div>
        </mat-menu>
        <mat-icon [matMenuTriggerFor]="profileMenu">account_circle</mat-icon>
      </div>
    </mat-toolbar>
}


<router-outlet/>
